<template>
  <main class="spinner_cont_page column main__">
    <img class="row success" src="@/assets/success.svg" alt="success">

    <div class="row">
      <h1>Thanks for your rating</h1>
    </div>

    <p class="subtitle">
      Your feedback has been submitted successfully.
    </p>

    <!-- <button class="column flex_center btnn" @click="lets_go">
      OK
    </button> -->
  </main>
</template>
<script>
export default {
  name: "ThanksForRating",

  methods: {
    lets_go() {
      // SPA-safe navigation
      this.$router.replace({ name: "home" });
    }
  }
};
</script>
<style scoped>
.main__ {
  z-index: 100;
}

.spinner_cont_page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  text-align: center;
}

img {
  margin-bottom: 10px;
  width: 25%;
}

h1 {
  font-size: 26px;
}

.subtitle {
  font-size: 20px;
  color: #515151;
  margin-bottom: 15px;
}

button {
  background-color: #317BEB;
  border: 0;
  padding: 10px 40px;
  color: #F2F2F2;
  font-size: 18px;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 500;
  border-radius: 3px;
  cursor: pointer;
  align-self: end;
}

.success {
  max-width: 175px;
}

@media (max-width: 500px) {
  h1 {
    font-size: 22px;
  }
}
</style>
